import axios from "./axios";

export const getBrokerOrderBook = async (order_status) => {

    const payload = {
        "type" : "order_book",
        "status" : order_status
    }

    const response = await axios.get(`/api/broker-gateway/broker-book/`, {
        params : payload
    });

    return response.data;

}

export const getBrokerPositionBook = async () => {

    const payload = {
        "type" : "position_book",
    }

    const response = await axios.get(`/api/broker-gateway/broker-book/`, {
        params : payload
    });

    return response.data;

}

export const getBrokerHoldingBook = async () => {

    const payload = {
        "type" : "holding_book",
    }

    const response = await axios.get(`/api/broker-gateway/broker-book/`, {
        params : payload
    });

    return response.data;

}

export const getBrokerHoldingBookColumns = async () => {

    const response = await axios.get("/api/analytics/table-schema/holding_book_columns/");

    return response.data;

}

export const getBrokerPositionBookColumns = async () => {

    const response = await axios.get("/api/analytics/table-schema/position_book_columns/");

    return response.data;

}

export const getBrokerOrderBookColumns = async () => {

    const response = await axios.get("/api/analytics/table-schema/order_book_columns/");

    return response.data;

}

export const postSquareOff = async (payload) => {
    const response = await axios.post("/api/broker-gateway/square-off/", payload);
    return response.data;
};

export const postAddMore = async (payload) => {
    const response = await axios.post("/api/broker-gateway/add-more/", payload);
    return response.data;
};